import api from "./api";

export const profileService = {
  getMyProfile: () => api.get("/profile/me").then((res) => res.data),
  updateMyProfile: (data) => api.put("/profile/me", data).then((res) => res.data),
  getPublicProfile: (id) => api.get(`/profile/${id}`).then((res) => res.data),
  getUserActivity: (id) => api.get(`/profile/${id}/activity`).then((res) => res.data),
  exportUserActivity: (id) => api.get(`/profile/${id}/activity/export`, { responseType: "blob" }).then((res) => res.data),
};
